var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBack = function SvgIconBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.756 14.97a1 1 0 0 1-1.593.804L.683 8.791a1 1 0 0 1 0-1.61l9.48-6.984a1 1 0 0 1 1.593.805v2.347a1 1 0 0 0 1 1H26a1 1 0 0 1 1 1v4.713a1 1 0 0 1-1 1H12.756a1 1 0 0 0-1 1z",
    clipRule: "evenodd"
  })));
};
export default SvgIconBack;